interface DashSectionTitleProps {
  title: string;
  subtitle?: string;
  id?: string;
}

const DashSectionTitle = ({ title, subtitle, id }: DashSectionTitleProps) => (
  <div className="dash-section-title" id={id}>
    <span className="dash-section-rule" />
    <div>
      <h2>{title}</h2>
      {subtitle && <p className="dash-section-subtitle">{subtitle}</p>}
    </div>
  </div>
);

export default DashSectionTitle;
